const THEORY_SECTIONS = [
  {
    id: 'principles',
    title: 'De 3 grundprinciperna',
    icon: '📚',
    content: `För att få resultat av din träning behöver du förstå tre grundläggande principer:

**1. Progressiv överbelastning**
Kroppen anpassar sig till belastning. För att bli starkare måste du gradvis öka kraven - antingen genom mer vikt, fler repetitioner, fler set eller kortare vila. Öka inte allt på en gång, utan en faktor i taget.

**2. Specificitet**
Du blir bättre på det du tränar. Vill du bli starkare i knäböj? Då måste du knäböja. Vill du springa snabbare? Då måste du springa. Välj övningar som matchar dina mål.

**3. Återhämtning**
Musklerna växer inte under träningen - de växer under vilan. En muskelgrupp behöver 48-72 timmar för att återhämta sig. Sömn, kost och stresshantering är lika viktigt som själva träningen.`
  },
  {
    id: 'sets-reps',
    title: 'Set, repetitioner och vila',
    icon: '🔢',
    content: `**Vad är vad?**
• **Repetition (rep)** = En hel rörelse (t.ex. en armhävning)
• **Set** = En samling repetitioner utan vila
• **Vila** = Paus mellan set

**Hur många reps för olika mål?**
• **Styrka:** 3-6 reps med tung vikt, 3-5 min vila
• **Muskeltillväxt:** 8-12 reps med medelvikt, 60-90 sek vila
• **Uthållighet:** 15-20+ reps med lätt vikt, 30-45 sek vila

**Hur många set?**
• Nybörjare: 2-3 set per övning
• Medel: 3-4 set per övning
• Avancerad: 4-5 set per övning

**Tumregel:** Sista reppet ska vara utmanande men med bibehållen teknik.`
  },
  {
    id: 'warmup',
    title: 'Uppvärmning',
    icon: '🔥',
    content: `En bra uppvärmning förbereder kroppen och minskar skaderisken.

**Steg 1: Allmän uppvärmning (5 min)**
• Lätt jogging, cykling eller roddmaskin
• Målet: Höja pulsen och kroppstemperaturen

**Steg 2: Dynamisk stretch (3-5 min)**
• Armcirklar framåt och bakåt
• Bensving fram/bak och i sida
• Höftcirklar
• Lätta knäböj utan vikt

**Steg 3: Specifik uppvärmning**
• 1-2 lätta set av första övningen
• Fokus på rörlighet och teknik

**Exempel:** Ska du knäböja med 60 kg?
1. Gör 10 reps utan vikt
2. Gör 8 reps med 30 kg
3. Gör 5 reps med 45 kg
4. Börja sedan ditt arbetssett med 60 kg`
  },
  {
    id: 'technique',
    title: 'Teknik före vikt',
    icon: '⚖️',
    content: `**Den viktigaste regeln: Teknik går alltid före vikt!**

Dålig teknik leder till:
• Skador på leder och muskler
• Sämre resultat (fel muskler jobbar)
• Obalanser i kroppen

**Grundregler för bra teknik:**

**Rygg & Core**
• Håll alltid ryggen i neutralt läge (naturlig svank)
• Spänn magen innan du lyfter
• Undvik rundad rygg vid lyft

**Knän**
• Knäna ska följa tårnas riktning
• Tryck ut knäna vid knäböj (inte inåt)
• Undvik att knäna går långt framför tårna

**Andning**
• Andas in i startposition
• Andas ut vid ansträngning (när du lyfter)
• Håll aldrig andan för länge

**Tempo**
• Kontrollerad rörelse i båda riktningar
• Sänk vikten i 2-3 sekunder
• Lyft i 1-2 sekunder
• Ingen svängning eller fusk`
  },
  {
    id: 'nutrition',
    title: 'Kost och träning',
    icon: '🍎',
    content: `**Före träning (1-2 timmar innan)**
• Kolhydrater för energi (bröd, frukt, havregryn)
• Lite protein
• Undvik för mycket fett (tar lång tid att smälta)
• Drick vatten

**Under träning**
• Drick vatten regelbundet
• Vid pass över 60 min: överväg sportdryck

**Efter träning (inom 1-2 timmar)**
• Protein för muskelåterhämtning (20-40g)
• Kolhydrater för att fylla på energidepåerna
• Exempel: Proteinshake + banan, eller kycklingmacka

**Generellt**
• Ät tillräckligt med protein: 1.6-2.2g per kg kroppsvikt
• Kolhydrater är inte fienden - de ger energi
• Sov 7-9 timmar för optimal återhämtning`
  },
];

export { THEORY_SECTIONS };
